import { LinkHandler } from "@/components/common/LinkHandler";
import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { NavBanner } from "@/types/promoData";
import { GA4 } from "@/utils/ga4Utils";

type PromoSaleBannerProps = {
  data?: NavBanner;
  toggleNav?: (isOpen: boolean) => void;
};

// 3. Component using the data prop
const PromoSaleBanner = ({ data, toggleNav }: PromoSaleBannerProps) => {
  if (!data) {
    return null;
  }

  const { path, label, promoText, images } = data;

  const handleAnalytics = () => {
    // Handle Navigation Toggle
    if (toggleNav) {
      setTimeout(() => toggleNav(false), 50);
    }
    GA4.onNavigationClicked({
      destination: path,
      text: label,
      type: "link",
    });
  };

  return (
    <LinkHandler onClick={handleAnalytics} path={path} aria-label={label} className="lg:ml-auto">
      <div className="promo-sale-banner m-6 -mb-2 px-6 py-4 relative lg:h-full lg:m-0 lg:w-[250px] lg:p-8 xl:w-[273px]">
        {/* Responsive Images */}
        <Picture
          src={images.mobile}
          alt=""
          role="presentation"
          className="rounded-sm lg:rounded absolute inset-0 w-full h-full object-cover md:hidden"
        />
        <Picture
          src={images.tablet}
          alt=""
          role="presentation"
          className="rounded-sm lg:rounded absolute inset-0 w-full h-full object-cover hidden md:block lg:hidden"
        />
        <Picture
          src={images.desktop}
          alt=""
          role="presentation"
          className="rounded-sm lg:rounded absolute inset-0 w-full h-full object-cover hidden lg:block"
        />

        <div className="flex flex-col items-center gap-2 lg:items-stretch lg:h-full">
          <TextElementNova
            text={promoText}
            classes={{
              default: "Body-30-Dia-Normal",
              768: "Body-30-Dia-Normal",
              1024: "Body-20-Dia-Normal",
            }}
            className="text-nova-base-white relative text-center"
          />

          <ButtonNova
            label={label}
            icon={"Right"}
            level={"Tertiary"}
            className="relative lg:mt-auto"
            copyClassName="text-nova-base-white"
          />
        </div>
      </div>
    </LinkHandler>
  );
};

export default PromoSaleBanner;
